export const isPast = (endDate: Date, now: Date) => {
  const { days, hours, minutes } = getTimeRemaining(endDate, now);
  return days === '00' && hours === '00' && minutes === '00';
};

export const getTimeRemaining = (
  endDate: Date,
  now: Date
): {
  days: string;
  hours: string;
  minutes: string;
} => {
  const diffMs = endDate.getTime() - now.getTime();

  if (diffMs <= 0) {
    return { days: '00', hours: '00', minutes: '00' };
  }

  const totalMinutes = Math.floor(diffMs / (1000 * 60));
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;

  const pad = (n: number): string => n.toString().padStart(2, '0');

  return {
    days: pad(days),
    hours: pad(hours),
    minutes: pad(minutes),
  };
};
